import OrderCreate from '@/pages/v2/OrderCreate'

export default [
  {
    path: '/app/v2/order/create',
    name: 'order_create',
    component: OrderCreate,
  }
]
